import {
    Component,
    Input,
    OnInit,
    ViewEncapsulation,
    Inject,
    NgZone,
    ViewChild,
    AfterViewInit,
    HostListener,
    EventEmitter
} from '@angular/core';

@Component({
    selector: 'dashboard-card',
    // template: `
    //     <div *ngIf="(sites.length > 0) && (!fullscreenEnabled())" id="card-container" class="card-container">
    //         <form editable-form name="editableSiteInfo" onaftersave="saveEdit()">
    //             <div class="row1">
    //                 <div class="topbanner">
    //                     <p class="sitename">{{currentSite.site}}</p>
    //                     <span>
    //                         <button type="button" ng-click="showCard =! showCard" ng-show="!editableSiteInfo.$visible">
    //                             <svg fill="#333333" height="24" width="24">
    //                                 <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"/>
    //                             </svg>
    //                         </button>
    //                         <button type="button" ng-click="editableSiteInfo.$show()" ng-show="(!editableSiteInfo.$visible && showCard)">
    //                             <svg fill="#333333" height="24" width="24">
    //                                 <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/>
    //                             </svg>
    //                          </button>
    //                     </span>
    //                     <span ng-show="editableSiteInfo.$visible">
    //                          <button type="submit" ng-disabled="editableSiteInfo.$waiting">
    //                             <svg fill="#333333" height="24" width="24">
    //                                 <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"/>
    //                             </svg>
    //                         </button>
    //                          <button type="button" ng-disabled="editableSiteInfo.$waiting" ng-click="editableSiteInfo.$cancel()">
    //                             <svg fill="#C42420" height="24" width="24">
    //                                 <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
    //                             </svg>
    //                         </button>
    //                     </span>
    //                 </div>
    //                 <div class="leftCol" ng-show="showCard">
    //                     <p>Email</p>
    //                     <p>Name</p>
    //                     <p>Number</p>
    //                     <p>Position</p>
    //                     <p ng-show="editableSiteInfo.$visible">Location</p>
    //                 </div>
    //                 <div class="rightCol" ng-show="showCard">
    //                     <p editable-text="currentSite.contact_email" e-name="contact_email" e-required>{{currentSite.contact_email}}</p>
    //                     <p editable-text="currentSite.contact_name" e-name="contact_name" e-required>{{currentSite.contact_name}}</p>
    //                     <p editable-text="currentSite.contact_number" e-name="contact_number" e-required>{{currentSite.contact_number}}</p>
    //                     <p editable-text="currentSite.contact_position" e-name="contact_position" e-required>{{currentSite.contact_position}}</p>
    //                     <p ng-show="editableSiteInfo.$visible" editable-text="currentSite.location" e-name="location" e-required></p>
    //                 </div>
    //             </div>
    //             <div class="row1" ng-repeat="sensor in currentSite.sensors" ng-show="showCard">
    //                 <div class="leftCol">
    //                     <p>Sensor</p>
    //                     <p>Status</p>
    //                     <p>Description</p>
    //                 </div>
    //                 <div class="rightCol">
    //                     <p>{{sensor.sensor}}</p>
    //                     <p class="sensorstatus" ng-class="{ 'red' : (sensor.status != 'ok')}">{{sensor.status}}</p>
    //                     <p editable-textarea="sensor.description" e-name="{'description' + $index}" e-required>{{sensor.description}}</p>
    //                 </div>
    //             </div>
    //         </form>
    //         <div ng-click="inspect()" class="inspectBttn">
    //             <p>Inspect</p>
    //         </div>
    //     </div>
    // `,
    // template: `
    //     <div *ngIf="(sites.length > 0) && (!fullscreenEnabled())" id="card-container" class="card-container">
    //         <form>
    //             <div class="row1">
    //                 <div class="topbanner">
    //                    <p class="sitename">{{currentSite.site}}</p>
    //                </div>
    //             </div>
    //         </form>
    //         <div (click)="inspect()" class="inspectBttn">
    //             <p>Inspect</p>
    //         </div>
    //     </div>
    // `,
    template: `
        <div *ngIf="(sites.length > 0) && (!fullscreenEnabled())" id="card-container" class="card-container">
            <form>
                <div class="row1">
                    <div class="topbanner">
                       <p class="sitename">M4Sensor</p>
                   </div>
                </div>
            </form>
            <div (click)="inspect()" class="inspectBttn">
                <p>Inspect</p>
            </div>
        </div>
    `,
    // encapsulation: ViewEncapsulation.Native,
})
export class DashboardCardComponent {
    @Input() private fullscreenEnabled;
    @Input() private currentSite;
    @Input() private sites;
    constructor(
        @Inject('$location') private location,
        @Inject('Window') private window,
        @Inject('Document') private document
    ) {}
    // saveEdit() {
    //     if (($scope.editableSiteInfo.$invalid) || $scope.editableSiteInfo.$pristine) { return }
    //     $http({
    //         method: 'POST',
    //         url: api+'/api/landing/savesiteinfo',
    //         data: {
    //             site: dashCtrl.currentSite
    //         }
    //     })
    //     .success(function (result) {
    //         // move the point if it's been updated
    //         dashCtrl.movePoints(result);
    //         //reset pristine stat
    //         $scope.editableSiteInfo.$setPristine();
    //     })
    //     .error(function (err) {
    //         console.log(err);
    //     })
    // }
    inspect() {
        if (this.location.$$search.hasOwnProperty('start') && this.location.$$search.hasOwnProperty('end')) {
            // copy the time and strip out any other vars when clicking sidebar items
            let time = { start: this.location.$$search.start, end: this.location.$$search.end }
            this.location.path('outbound_ioc').search(time);
        } else {
            this.location.path('outbound_ioc').search({});
        }
    }
}


//             // create external function for the edit pane to update points with
//             dashCtrl.movePoints = function(location) {
//                 // console.log(dashCurrentSite)
//                 // find the current site and update the latlong
//                 const current = dashCurrentSite;
//                 for (let i = 0, len = dashSites; i < len; i++) {
//                     if (dashSites[i].site === current.site) {
//                         // update list items
//                         dashSites[i].lat = location.lat;
//                         dashSites[i].long = location.lon;
//                         dashSites[i].LatLng = {
//                             lat: location.lat,
//                             lng: location.lon
//                         }
//                     }
//                 }
//                 // also update the current set location
//                 dashCurrentSite.lat = location.lat;
//                 dashCurrentSite.long = location.lon;
//                 dashCurrentSite.LatLng = {
//                     lat: location.lat,
//                     lng: location.lon
//                 }
//                 // re-reduce the sites
//                 const sites = animation.reducer(dashSites);
//                 // clear everything
//                 animation.wipeClean();
//                 // draw the sites
//                 animation.drawSites(sites);
//                 // mark current active site
//                 animation.markCurrentSiteBlock(dashCurrentSite);
//             }

//




/** WEBPACK FOOTER **
 ** ./src/landing/directives/dashboard/dashboard.card.component.ts
 **/